import React from "react";
import { cn } from "../../lib";
interface IICSwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  containerClassName?: string;
}
const ICSwitch: React.FC<IICSwitchProps> = ({
  containerClassName,
  placeholder,
  required = false,
  disabled = false,
  checked,
  onChange,
}) => {
  const handleOnChange = () => {
    onChange(!checked);
  };

  return (
    <div
      className={cn("flex items-center", {
        [`${containerClassName}`]: containerClassName,
      })}
    >
      {placeholder && <div>{placeholder + (required ? "*" : "")}</div>}
      <div
        onClick={() => (!disabled ? handleOnChange() : {})}
        className={cn(
          `relative inline-flex items-center h-[18px] w-9 rounded-full duration-300 focus:outline-none overflow-hidden `,
          {
            "bg-disable": disabled,
            "cursor-pointer": !disabled,
            "bg-accent-emphasis": checked && !disabled,
            "bg-inset": !checked,
          }
        )}
      >
        <span
          className={cn(
            `absolute grid place-items-center h-3.5 w-3.5 transform rounded-full bg-subtle transition-transform duration-300 ease-in-out`,
            {
              "translate-x-5": checked,
              "translate-x-[2.5px] shadow-inner": !checked,
            }
          )}
        ></span>
      </div>
    </div>
  );
};

export default ICSwitch;
